import { useState, useEffect, useCallback } from 'react';
import { useSseSubscribe, sseAssetsStatusOptions } from 'packages/sse';
import { AssetStatus } from 'packages/types/assets';
import type { AssetStatusItem } from 'packages/services/assetsService';

const useImageGenPendingAsset = () => {
    const [pendingIds, setPendingIds] = useState<string[]>([]);

    const addPendingId = useCallback((id: string) => {
        setPendingIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
    }, []);

    const removePendingId = useCallback((id: string) => {
        setPendingIds((prev) => prev.filter((item) => item !== id));
    }, []);

    const isPending = useCallback((id: string) => pendingIds.includes(id), [pendingIds]);

    const handleTerminalStatus = useCallback(
        (items: AssetStatusItem[]) => {
            items.forEach((item) => {
                if (item.status === AssetStatus.PROCESSED || item.status === AssetStatus.COMPLETED) {
                    removePendingId(item.id);
                }
            });
        },
        [removePendingId],
    );

    const subscribe = useSseSubscribe(
        sseAssetsStatusOptions({ assetIds: pendingIds, onMessage: handleTerminalStatus }),
    );

    useEffect(() => {
        if (pendingIds.length) {
            return subscribe();
        }
    }, [subscribe, pendingIds]);

    return {
        pendingIds,
        addPendingId,
        removePendingId,
        isPending,
    };
};

export default useImageGenPendingAsset;
